/** Отображение цены товара в каталоге/карточке (единый вид на всех клиентах).
 *
 * Показываем цену ЗА ВЫЧЕТОМ кэшбека + сумму кэшбека в рублях (как в Android).
 * Формула совпадает с Android (Catalog.priceUI):
 *   refund = round(price * pct / 100), final = max(0, price − refund).
 */

/** Число → «1 528» (разряды пробелом, как в приложениях). */
export function ru(n) {
  return Number(n).toLocaleString("ru-RU");
}

/** { finalLabel, refund }: цена после кэшбека (строка) + кэшбек в рублях. */
export function priceView(item) {
  const pct = item && item.cashbackPercent > 0 ? item.cashbackPercent : 0;
  const price = item ? item.priceRub : null;
  if (price == null) return { finalLabel: (item && item.subtitle) || "", refund: 0 };
  const refund = pct > 0 ? Math.round((price * pct) / 100) : 0;
  const finalPrice = Math.max(0, price - refund);
  return {
    finalLabel: finalPrice > 0 ? `${ru(finalPrice)} ₽` : "Бесплатно",
    refund,
  };
}
